/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Header_Ai_Api_Reference_LabelInputs */

const en_common_header_ai_api_reference_label = /** @type {(inputs: Common_Header_Ai_Api_Reference_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API Reference`)
};

const zh_common_header_ai_api_reference_label = /** @type {(inputs: Common_Header_Ai_Api_Reference_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API 参考`)
};

/**
* | output |
* | --- |
* | "API Reference" |
*
* @param {Common_Header_Ai_Api_Reference_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_header_ai_api_reference_label = /** @type {((inputs?: Common_Header_Ai_Api_Reference_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Header_Ai_Api_Reference_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_header_ai_api_reference_label(inputs)
	return zh_common_header_ai_api_reference_label(inputs)
});
export { common_header_ai_api_reference_label as "common.header.ai.api_reference.label" }